<div id="preauthWrapper">
    <div class="preauth-dialog">
        <div id="divErrorInvalidAccount">
            <h1>Sorry, we can't find {{hostname}}</h1>
            <p>The website could have moved or you might have mistyped the URL.</p>
            <p>If you have an account with Buildium you can try to sign in at:<br />
                <a [href]="globalSignInUrl">{{globalSignInUrl}}</a></p>
            <p>Don't have an account with us? We would love to help you out!<br />
                <a href="http://www.buildium.com">Sign up for a FREE trial at Buildium.com</a></p>
        </div>
    </div>
</div>
